@if (formGroup) {
  @if (formGroup.get(formGroupOrControlName); as control) {
    <div [formGroup]="formGroup" class="metabi-control">
      <app-field-label [for]="formGroupOrControlName">
        {{ getLabel() }}
      </app-field-label>
      <input
        [formControlName]="formGroupOrControlName"
        type="checkbox"
        [placeholder]="getLabel()"
        />
      @if (control.errors && control.touched) {
        <app-field-error>
          {{ curateValidationHint(control) }}
        </app-field-error>
      }
    </div>
  }
}
